// src/services/supportService.ts
import { apiService } from './apiService';
import { API_ENDPOINTS } from '../config/api.config';
import type { TicketResponse, TicketCreationResponse } from '../types/support';

export const supportService = {
    createTicket: async (formData: FormData): Promise<TicketCreationResponse> => {
        try {
            // Use apiService's raw fetch with auth headers for FormData
            const headers = await apiService['getAuthHeaders'](); // accessing private method
            // Don't set Content-Type for FormData
            headers.delete('Content-Type');

            const response = await fetch(API_ENDPOINTS.SUPPORT.CREATE_TICKET, {
                method: 'POST',
                headers,
                body: formData,
                credentials: 'include'
            });

            if (!response.ok) {
                throw new Error('Failed to create ticket');
            }

            return response.json();
        } catch (error) {
            console.error('Error creating ticket:', error);
            throw error;
        }
    },

    async getTickets(page: number = 1, includeResolved: boolean = false): Promise<TicketResponse> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: '10',
            includeResolved: includeResolved.toString()
        });

        return apiService.get<TicketResponse>(
            `${API_ENDPOINTS.SUPPORT.LIST_TICKETS}?${params}`
        );
    },

    async getTicketDetails(ticketId: string) {
        return apiService.get(
            API_ENDPOINTS.SUPPORT.GET_TICKET.replace(':id', ticketId)
        );
    }
};